var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top_cards"},[_c('balance-card',{staticClass:"top_card balance_card"}),_c('address-card',{staticClass:"top_card addr_card"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }